import React from "react";
import { useParams } from "react-router-dom";
import { Alert, Button, Modal, Table, Tag } from "antd";

import useGet from "hooks/useGet";
import useCreate from "hooks/useCreate";

const AddDeviceModal = ({ worker_devices, handleClose, refetch }) => {
  const { id: worker_id } = useParams();
  const { is_loading, data } = useGet({
    path: "/devices",
    query: ["devices_list"],
    context: "list",
    search: {
      per_page: 200,
    },
  });
  const can_add_device = worker_devices?.length < 2;

  const { is_saving, create } = useCreate({
    path: "/worker_devices",
  });

  const handleAssign = async (device_id) => {
    try {
      await create({
        worker_id,
        device_id,
      });
      await refetch();
    } catch (error) {
      console.log(error);
    }
  };

  const devices = (data || [])?.map(({ id, name, imei }) => ({
    key: id,
    id,
    imei,
    name,
    is_assigned: worker_devices.some(
      (worker_device) => worker_device?.device?.id === id
    ),
    is_disabled: !can_add_device,
  }));

  const columns = [
    {
      title: "ID urządzenia",
      dataIndex: "imei",
    },
    {
      title: "Nazwa",
      dataIndex: "name",
    },
    {
      title: "",
      dataIndex: "action",
      width: 120,
      render: (_, record) => (
        <div style={{ textAlign: "center" }}>
          {record.is_assigned ? (
            <Tag color="green" className="text-center">
              Przypisany
            </Tag>
          ) : (
            <Button
              loading={is_saving}
              disabled={record.is_disabled}
              htmlType="button"
              onClick={() => handleAssign(record.id)}
              type="primary"
            >
              Przypisz
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <Modal
      style={{ top: 45 }}
      maskClosable={false}
      width={800}
      title="Wybierz urządzenie"
      open={true}
      onCancel={handleClose}
      cancelText="Anuluj"
      okButtonProps={{
        style: { display: "none" },
      }}
    >
      <div style={{ padding: "20px 0" }}>
        <Alert
          className="m-b-20"
          type="info"
          message={
            <>
              Limit: <strong> {worker_devices?.length}/2</strong>
            </>
          }
        />
        {!can_add_device && (
          <Alert
            className="m-b-20"
            type="error"
            message={
              <>
                <strong>Osiągnięto limit.</strong> Pracownik może posiadać
                maksymalnie <strong>2</strong> przypisane urządzenia.
              </>
            }
          />
        )}
        <Table
          loading={is_loading}
          bordered
          columns={columns}
          dataSource={devices}
          size="small"
        />
      </div>
    </Modal>
  );
};

export default AddDeviceModal;
